export default {
      id: "contacts-usage",
      viewBox: "0 0 66.09 72.96",
      url: "../dist/images/" + "sprite.svg#contacts-usage",
      toString: function () {
        return this.url;
      }
    }